<template>
  <div class="__topbar">
    <b-sidebar class="__navmenu" fullheight :open.sync="OpenNav">
      <close-button class="close" @close="OpenNav = false" />
      <div class="buffer"></div>
      <nav-link url="/dashboard" :icon="['fas', 'book']">Course</nav-link>
      <div class="__nav_item" @click="OpenNav = false; OpenGlossary = true">
        <font-awesome-icon :icon="['fas', 'question-circle']" />
        <span>
          Glossary
        </span>
      </div>
      <!-- <nav-link url="/glossary" :icon="['fas', 'question-circle']"
        >Glossary</nav-link> -->
      <!-- <nav-link url="/support" :icon="['fas', 'question-circle']"
        >Support</nav-link> -->
    </b-sidebar>

    <b-sidebar class="__glossary" fullheight :open.sync="OpenGlossary">
      <close-button class="close" @close="OpenGlossary = false" />
      <glossary />
    </b-sidebar>

    <div class="">
      <menu-button class="__menu" @open="OpenNav = true" />
      <div class="title">{{ title }}</div>
      <div class="module">{{ module }}</div>
      <div class="progress" v-if="courseActive">
        <Progress />
      </div>
      <div class="user">
        <span class="is-hidden-mobile">{{ user.firstname }}</span>
        <user-button class="avatar" @open="OpenUser = true" />
        <!-- <div class="avatar" @click="OpenUser = true">
          <font-awesome-icon :icon="['fas','user']" />
        </div> -->
      </div>
    </div>

    <b-sidebar class="__usermenu" fullheight right :open.sync="OpenUser">
      <close-button class="close" @close="OpenUser = false" />
      <div class="user_image">
        <font-awesome-icon :icon="['fas', 'user']" />
      </div>
      <div class="status no-select">
        <font-awesome-icon :icon="['fas', 'circle']" />
        <span>online</span>
      </div>
      <div class="name">{{ user.firstname }} {{ user.lastname }}</div>
      <div class="email">
        {{ user.email }}
      </div>
      <div class="edit_info no-select">
        <font-awesome-icon :icon="['fas', 'edit']" />
        <span>edit my information</span>
      </div>
      <div class="edit_password no-select">
        <font-awesome-icon :icon="['fas', 'lock']" />
        <span>change my password</span>
      </div>
      <div class="signout no-select" v-on:click="logout">
        <span>signout</span>
        <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
      </div>
      <!-- <div class="notifications">
        <h1>Notifications</h1>
        <p>...</p>
      </div> -->
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import MenuButton from "@/components/MenuButton.vue";
import UserButton from "@/components/UserButton.vue";
import CloseButton from "@/components/CloseButton.vue";
import NavLink from "@/components/NavLink.vue";
import Progress from "@/components/Progress.vue";
import Glossary from "@/views/Glossary.vue";

export default {
  name: "Topbar",
  components: {
    MenuButton,
    UserButton,
    CloseButton,
    NavLink,
    Progress,
    Glossary
  },
  props: {
    title: {
      type: String,
      default: "Course Title"
    },
    module: {
      type: String,
      default: "Module Title"
    }
  },
  data() {
    return {
      OpenNav: false,
      OpenUser: false,
      OpenGlossary: false,
    };
  },
  methods: {
    ...mapActions("auth", ["logout"]),
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    courseActive() {
      return this.$store.state.courseActive;
    },
    mod() {
      return this.$route.params.module;
    },
  }
};
</script>

<style lang="scss">
@import "../theme.scss";

// Buefy Sidebar will not be nested when rendered.
.b-sidebar .sidebar-content {
  background-color: white !important;
}

.__glossary {
  position: relative;

  .sidebar-content {
    width: 300px !important;
    padding: 25px;
    padding-top: 50px;
    overflow: hidden !important;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

.__navmenu {
  position: relative;

  .sidebar-content {
    border-radius: 0px 30px 30px 0px;
    width: 190px !important;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .buffer {
    height: 70px;
  }
}

.__usermenu {
  position: relative;

  .sidebar-content {
    border-radius: 30px 0px 0px 30px;
    width: 300px !important;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .user_image {
    width: 200px;
    height: 200px;
    color: white;
    border-radius: 100%;
    line-height: 190px;
    font-size: 100px;
    margin: 50px 50px 15px 50px;
    text-align: center;
    background-color: $primary;
  }

  .status {
    text-align: center;
    font-size: 9px;
    color: #79bc5d;
    margin-bottom: 15px;

    span {
      color: $secondary;
      padding-left: 6px;
      font-size: 12px;
      font-weight: 600;
    }
  }

  .name {
    font-size: 22px;
    font-weight: 600;
    text-align: center;
  }

  .email {
    font-size: 16px;
    font-weight: 400;
    text-align: center;
  }

  .edit_info,
  .edit_password {
    width: 200px;
    height: 30px;
    background-color: #f5f5f5;
    color: #a5a5a5;
    font-size: 12px;
    border-radius: 26px;
    margin: 10px auto;
    line-height: 30px;
    text-align: center;
    cursor: pointer;

    span {
      font-size: 12px;
      font-weight: 600;
      padding-left: 4px;
    }

    &:hover {
      background-color: #e5e5e5;
    }
  }

  .signout {
    width: 110px;
    height: 40px;
    background-color: $secondary;
    color: white;
    font-size: 14px;
    border-radius: 26px;
    margin: 10px auto;
    line-height: 40px;
    text-align: center;
    cursor: pointer;

    span {
      font-size: 12px;
      font-weight: 600;
      padding-right: 8px;
      line-height: 35px;
    }

    &:hover {
      background-color: $primary;
    }
  }
}

.__topbar {
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: 40;
  height: 90px;
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */

  .__menu {
    float: left;
  }

  .title {
    font-size: 26px;
    position: absolute;
    top: 18px;
    left: 95px;
    font-weight: 600;
    margin: 0;
  }

  .module {
    font-size: 16px;
    position: absolute;
    top: 44px;
    left: 95px;
    font-weight: 400;
    margin: 0;
  }

  .progress {
    width: 350px;
    height: 90px;
    margin: 0px auto;
    border-radius: 0px;
  }

  .user {
    position: absolute;
    top: 0px;
    right: 25px;
    height: 60px;
    width: 200px;
    font-size: 22px;
    font-weight: 600;
    line-height: 80px;
    text-align: right;

    span {
      margin-right: 75px;
    }

    .avatar {
      position: absolute;
      top: 15px;
      right: 0px;
    }
  }
}
</style>
